import React from "react";
import PrimaryNav from "./components/PrimaryNav/PrimaryNav";

const App = () => (
  <div data-aos="fade-in">
    <PrimaryNav />
  </div>
);
export default App;
